/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { BuilderFormSchemaFactory, FormRootSchema, FormStateSchema, whenOfficeView } from '@gh/builder-shared';
import { ContactType } from '@gh/builder-shared-data';
import { FormState, mixinFilterableForm } from '@gh/common-shared';
import { collectValues } from '@gh/core-ui';
import { filter, find, get } from 'lodash';
import { ContactListFilter } from '../../resources/contact-list-filter.model';
import { ContactListInitType } from '../../resources/contact-list-init.model';

@Injectable()
export class ContactListFormState extends mixinFilterableForm<ContactListFilter>(FormState) {
  private typeDefs: ContactListInitType[];

  constructor(schemaFactory: BuilderFormSchemaFactory) {
    super(schemaFactory);
  }

  build(contactFilter: ContactListFilter, typeDefs: ContactListInitType[]): void {
    this.typeDefs = typeDefs;

    this.initSchema(contactFilter);
  }

  getFilterField(type: ContactType): FormControl {
    const formTypes = <FormGroup>this.group.get('types');

    return <FormControl>find(formTypes.controls, (formType) => formType.value.type === type);
  }

  getValue(): ContactListFilter {
    return collectValues(this.group);
  }

  protected buildSchema(contactFilter: ContactListFilter, { root, array, group }: FormStateSchema): FormRootSchema {
    const { typeDefs } = this;

    return root({
      children: {
        name: void 0,
        showInactive: void 0,
        types: array({
          enabled: whenOfficeView(),
          children: contactFilter.types.map(({ type }) => group({
            key: type,
            enabled: get(filter(typeDefs, { type }), 'allowed'),
            children: {
              type: void 0,
              checked: void 0,
            },
          })),
        }),
      },
    });
  }
}
